import { Box, styled, themeGet } from '@qwealth/qcore';

export const NoteCard = styled(Box)<{ isSelected?: boolean }>`
  width: 98%;
  background-color: ${props => (props.isSelected ? themeGet('colors.primaryLight.0') : themeGet('colors.gray.4'))};
  border: none;
  filter: drop-shadow(4px 4px 2px rgba(0, 0, 0, 0.1));

  color: ${props => (props.isSelected ? themeGet('colors.primaryLight.1') : themeGet('colors.dark'))};

  padding: ${themeGet('space.default')};
  border-radius: ${themeGet('radii.default')};
  display: flex;

  margin-right: ${themeGet('space.large')};
  margin-bottom: ${themeGet('space.large')};
  justify-content: space-between;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${props => (props.isSelected ? themeGet('colors.primaryLight.0') : themeGet('colors.gray.3'))};
    color: ${themeGet('colors.primaryLight.1')};
    transform: translateY(-1px);
  }
`;

interface BottomNoteCardProps {
  isHovered: boolean;
}

export const BottomNoteCard = styled(Box)<BottomNoteCardProps>`
  position: absolute;
  width: 97.5%;
  z-index: -1;
  top: 5px;
  left: 10px;
  background-color: ${themeGet('colors.gray.4')};
  transition: background-color 0.15s ease-in-out;
  border-radius: ${themeGet('radii.default')};
  filter: drop-shadow(4px 4px 2px rgba(0, 0, 0, 0.1));
`;

export const NoteCardContainer = styled(Box)`
  position: relative;
  display: flex;
`;

export const OpenNoteModalButton = styled.button`
  background: none;
  background-color: none;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeGet('space.default')};
`;

export const StyledDeleteButton = styled.button`
  background: none;
  background-color: none;
  border: none;
  color: ${themeGet('colors.gray.1')};

  &:hover {
    color: ${themeGet('colors.primaryLight.1')};
  }
`;

export const StyledIconContainer = styled(Box)<{ isHovered: boolean }>`
  color: ${props => (props.isHovered ? themeGet('colors.primaryLight.1')(props) : themeGet('colors.gray.1')(props))};

  transition: color 0.15s ease-in-out;
`;

export const KYCTagBox = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${themeGet('space.default')};

  @media (max-width: 345px) {
    display: none;
  }
`;

export const WarningBox = styled(Box)`
  background-color: #f9f5d2;
`;

export const PreviewCardHouseholdLink = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: ${themeGet('fontWeights.bold')};
  gap: ${themeGet('space.small')};
  width: fit-content;
  cursor: pointer;

  &:hover {
    color: ${themeGet('colors.primaryLight.1')};
  }
`;
